<template>
  <v-dialog v-model="alertDialog" :max-width="$vuetify.breakpoint.mobile ? '95%' : '50%'" persistent>
    <v-form ref="form" @submit.prevent="submitForm">
      <v-card class="mx-auto py-4">
        <v-card-text>
          <div v-html="loGet(dialogContent,'formBody','The form content')"></div>
        </v-card-text>
        <v-card-actions>
          <v-btn text color="primary" class="t-compose-send-btn" type="submit">{{ loGet(dialogContent, 'submit.btnText', 'Submit') }}</v-btn>
          <v-spacer/>
          <v-btn text @click="alertDialog = false">{{ loGet(dialogContent, 'close.btnText', 'Close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>  
</template>

<script>
import loGet from 'lodash/get'
import { mapGetters } from "vuex";

export default {
  data: () => ({
    alertDialog: false
  }),

  watch: {
    dialogContent(val) {
      // Pop form if dialogContent has any value
      if (val) {
        this.alertDialog = true
      }
    },
  },

  computed: {
    ...mapGetters('app', ["dialogContent", "currentRightsholder"]),
  },

  methods: {
    loGet,

    async submitForm(form) {
      // Assemble stuff from form to data
      const data = {}
      for (const el of form.target.elements) {
        if (el.name) {
          switch (el.type) {
            case "checkbox":
              data[el.name] = el.checked
              break;
            default:
              data[el.name] = el.value
          }
        }
      }
      const formName = loGet(this, 'currentRightsholder.docuri', 'form1')
      // Call api
      const res = await this.$store.dispatch('app/submitCustomForm', {data, ...this.loGet(this.dialogContent, 'formAction', {method: 'POST', url: '/api/v1/forms/' + formName})  });
      // Show message if any
      const message = this.loGet(res, 'data.message', null)
      if (message) {
        this.$toast(message)
      }
      // Close dialog
      this.alertDialog = false
    },
  }
}
</script>

<style>

</style>